import { Portal, PortalProvider } from '@semcore/base-components';
import type { PortalProps } from '@semcore/base-components';

export {
  /**
   * @deprecated Use Portal from `@semcore/base-components` instead. Package `@semcore/portal` will be removed in the next major release
   */
  Portal,
  /**
   * @deprecated Use PortalProvider from `@semcore/base-components` instead. Package `@semcore/portal` will be removed in the next major release
   */
  PortalProvider,
  /**
   * @deprecated Use PortalProps from `@semcore/base-components` instead. Package `@semcore/portal` will be removed in the next major release
   */
  type PortalProps,
};
/**
 * @deprecated Use Portal from `@semcore/base-components` instead. Package `@semcore/portal` will be removed in the next major release
 */
export default Portal;
